import { shouldHideIfEmpty } from '@/helpers/constants/hideEmptyFields';
import { isHeaderOrFooterField } from '@/helpers/constants/lockableFields';
import { htmlToText } from '@ui/helpers/htmlToText';

const getBlocks = (field) => {
  const blocks = [];
  (field.sections || []).forEach((section) => {
    (section.blocks || []).forEach((block) => {
      blocks.push(block);
    });
  });
  return blocks;
};

export const joinFooterAndHeaderFields = (fields) => fields.reduce((res, originalField, i) => {
  const field = JSON.parse(JSON.stringify(originalField));

  if (isHeaderOrFooterField(field.type)) {
    return res;
  }

  const prev = fields[i - 1];
  if (prev?.type === `${field.type}__header` && !shouldHideIfEmpty(prev)) {
    const prevBlocks = getBlocks(prev);
    const blocks = getBlocks(field);
    if (field.sections && field.sections[0]) {
      // eslint-disable-next-line no-param-reassign
      field.sections[0].blocks = [...prevBlocks, ...blocks];
    }
  }

  const next = fields[i + 1];
  if (next?.type === `${field.type}__footer` && !shouldHideIfEmpty(next)) {
    const nextBlocks = getBlocks(next);
    const blocks = getBlocks(field);
    if (field.sections && field.sections[0]) {
      // eslint-disable-next-line no-param-reassign
      field.sections[0].blocks = [...blocks, ...nextBlocks];
    }
  }

  field.html = getBlocks(field)
    .map((block) => block.html)
    .join('\n');

  field.text = htmlToText(field.html);

  res.push(field);
  return res;
}, []);
